import * as React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import cloneDeep from 'lodash/cloneDeep';

import {
  saveUserSubscriptionExternal,
  getUserContentSubscriptionsExternal,
} from 'src/action-creators/content-subscription';

import {selectUserContentSubscriptionExternal} from 'src/selectors/content-subscription';

import ContentCategoryManagement from 'src/components/content-subscription/manage/content-category-management';


const ManageSubscription = ({
  params: {
    attributeName,
    attributeValue,
    entityId,
    entityType,
    isDebugEntity,
    sentEventId,
  },
}: {
  params: {
    isDebugEntity: boolean;
    sentEventId: string;
    unsubscribeCategoryId: string;
    attributeValue: string;
    attributeName: string;
    entityId: string;
    entityType: string;
    deliveryAddress: string;
  };
}) => {
  const dispatch = useDispatch();
  const [success, setSuccess] = React.useState(false);

  const userContentSubscriptionsFromStore = useSelector((state) =>
    selectUserContentSubscriptionExternal(state, entityId),
  );

  // storing the store's subscriptions data into local state
  // this will enable us to let users play with the subscription toggles
  // in the page and later when they save, we do a bulk update
  // discard button will just throw away this local state and fetch from store again
  const [userContentSubscriptionsLocal, setUserContentSubscriptionsLocal] =
    React.useState([]);

  React.useEffect(() => {
    if (!isDebugEntity && attributeName) {
      dispatch(
        getUserContentSubscriptionsExternal(
          entityType,
          entityId,
          attributeName,
        ),
      );
    }
  }, [attributeName]);

  React.useEffect(() => {
    setUserContentSubscriptionsLocal(
      // @ts-expect-error - TS2345 - Argument of type 'UserContentSubscriptionsExternal' is not assignable to parameter of type 'SetStateAction<never[]>'.
      cloneDeep(userContentSubscriptionsFromStore || []),
    );
  }, [userContentSubscriptionsFromStore]);

  const onSubscriptionToggle = React.useCallback(
    // @ts-expect-error - TS7006 - Parameter 'categoryId' implicitly has an 'any' type. | TS7006 - Parameter 'checked' implicitly has an 'any' type.
    (categoryId, checked) => {
      const newLocalState = [...userContentSubscriptionsLocal];
      newLocalState.forEach((contentSubscription) => {
        if (
          // @ts-expect-error - TS2339 - Property 'content_subscription_category_id' does not exist on type 'never'.
          contentSubscription.content_subscription_category_id === categoryId
        ) {
          // @ts-expect-error - TS2339 - Property 'subscription' does not exist on type 'never'.
          contentSubscription.subscription[0].is_subscribed = checked;
        }
      });
      setUserContentSubscriptionsLocal(newLocalState);
    },
    [
      userContentSubscriptionsLocal,
      userContentSubscriptionsFromStore,
      setUserContentSubscriptionsLocal,
    ],
  );

  const onSave = async () => {
    try {
      await dispatch(
        saveUserSubscriptionExternal(
          entityType,
          entityId,
          userContentSubscriptionsLocal,
          true,
          sentEventId,
        ),
      );
      setSuccess(true);
    } catch (e: any) {}
  };

  return (
    <ContentCategoryManagement
      onSave={onSave}
      onSubscriptionToggle={onSubscriptionToggle}
      isDebugEntity={isDebugEntity}
      attributeValue={attributeValue}
      success={success}
      userContentSubscriptionsLocal={userContentSubscriptionsLocal}
    />
  );
};

export default ManageSubscription;
